<!-- @format -->

<template>
	<div style="width: 100%; height: 100%">
		<slot name="check-data"></slot>
		<van-col :span="24" :style="{ 'text-align': buttonFrontAlign ? buttonFrontAlign : 'left' }">
			<van-space v-if="showTableBtn" class="table-btns">
				<slot name="button-front"></slot>
				<van-button v-if="canExport" @click="show = true"> 导出 </van-button>
			</van-space>
		</van-col>
		<div class="data-list">
			<template v-if="!loading">
				<template v-if="data && data.length > 0">
					<van-collapse ref="collapseRef" v-model="activeNames">
						<van-checkbox-group v-model="checkId" @change="handleSelectionChange">
							<div v-for="(scope, index) in data" :key="index" class="data-item" @click="handleRowClick(scope)">
								<div class="checkbox-box">
									<van-checkbox
										v-if="multiple"
										style="padding: 3px"
										:name="scope[rowKey]"
										@click="
											(e) => {
												e.stopPropagation();
											}
										"
									/>
								</div>
								<van-collapse-item :name="scope[rowKey]" :border="false" :disabled="!collapse" :is-link="collapse">
									<template #title>
										<van-row>
											<template v-for="(item, idx) in columnList" :key="item.code">
												<van-col v-if="idx <= indexcolumnList" :span="item.cols || 24">
													<van-field
														:name="item.code"
														:is-link="item.isLink && item.isShowArrow"
														:label-width="
															idx !== 0
																? labelAuto
																	? 'auto'
																	: item.colProps && item.colProps.width
																	? item.colProps.width
																	: labelWidth
																: 0
														"
														:label-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
														:input-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
														class="label-padding"
														@click="(e) => handleItemClick(e, scope, item.isLink)"
													>
														<template v-if="idx !== 0 && !item.hiddenLabel" #label>
															<slot :name="`column-default-label-${item.code}`" v-bind="scope">
																{{ item.label }}:
															</slot>
														</template>
														<template #input>
															<div :class="idx !== 0 ? 'width-100' : 'data-title'">
																<slot
																	:name="`column-default-${item.code}`"
																	v-bind="scope"
																	:model-value="scope[item.code]"
																	:disabled="true"
																	:type="item.type"
																>
																	<component
																		:is="getComponentMobile(item.type)"
																		:model-value="scope[item.code]"
																		:disabled="true"
																		v-bind="item.pcProps"
																		:show-tag="idx !== 0"
																	/>
																</slot>
															</div>
														</template>
													</van-field>
												</van-col>
											</template>
										</van-row>
									</template>
									<van-row>
										<template v-for="(item, idx) in columnList" :key="item.code">
											<van-col v-if="idx > indexcolumnList" :span="item.cols || 24">
												<van-field
													:name="item.code"
													:is-link="item.isLink && item.isShowArrow"
													:label-width="
														labelAuto ? 'auto' : item.colProps && item.colProps.width ? item.colProps.width : labelWidth
													"
													:label-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
													:input-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
													class="label-padding"
													@click="(e) => handleItemClick(e, scope, item.isLink)"
												>
													<template v-if="!item.hiddenLabel" #label>
														<slot :name="`column-default-label-${item.code}`" v-bind="scope"> {{ item.label }}: </slot>
													</template>
													<template #input>
														<div class="width-100">
															<slot
																:name="`column-default-${item.code}`"
																v-bind="scope"
																:model-value="scope[item.code]"
																:disabled="true"
																:type="item.type"
															>
																<component
																	:is="getComponentMobile(item.type)"
																	:model-value="scope[item.code]"
																	:disabled="true"
																	v-bind="item.pcProps"
																/>
															</slot>
														</div>
													</template>
												</van-field>
											</van-col>
										</template>
									</van-row>
									<van-col
										v-if="settingColumnConfig && settingColumnConfig.length > 0"
										:span="24"
										:style="{ 'text-align': settingColumnAlign || 'left' }"
									>
										<van-divider style="margin: 5px" />
										<van-space>
											<slot name="column-default-column-setting" v-bind="scope">
												<template v-for="opt in settingColumnConfig" :key="opt.value">
													<van-button
														v-if="typeof opt.hidden === 'function' ? !opt.hidden(scope) : !opt.hidden"
														:disabled="typeof opt.disabled === 'function' ? opt.disabled(scope) : opt.disabled"
														v-bind="opt.prop"
														@click.stop="settingAction(opt.value, scope)"
													>
														{{ opt.label }}
													</van-button>
												</template>
											</slot>
										</van-space>
									</van-col>
								</van-collapse-item>
							</div>
						</van-checkbox-group>
					</van-collapse>
					<van-pagination
						v-if="showTotal && total > pageValue.pageSize"
						v-model="pageValue.pageNum"
						:total-items="total"
						:items-per-page="pageValue.pageSize"
						mode="simple"
					/>
				</template>
				<template v-else>
					<van-empty description="暂无数据" />
				</template>
			</template>
			<template v-else><van-loading size="24px" vertical>加载中...</van-loading> </template>

			<van-action-sheet
				v-model:show="show"
				:actions="actions"
				cancel-text="取消"
				close-on-click-action
				@select="onExport"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { download } from '@power/runtime-vue3';
	import type { ComponentType, SettingColumnConfigType, ExportProps } from './types';
	import { getComponentMobile } from '@/components';

	interface Props {
		data: any[];
		columnList: ComponentType[];
		loading?: boolean; // 是否加载
		total?: number; // 总数
		showTotal?: boolean;
		showTableBtn?: boolean;
		settingColumnConfig?: SettingColumnConfigType[];
		settingColumnAlign?: string;
		buttonFrontAlign?: string;
		pageValue?: {
			pageSize: number;
			pageNum: number;
		};
		multiple?: boolean;
		canExport?: boolean;
		exportProps?: {
			searchExport?: ExportProps;
			sheetExport?: ExportProps;
			allExport?: ExportProps;
		};
		labelAuto?: boolean;
		labelWidth?: string | number;
		labelAlign?: string;
		rowKey: string;
		collapse?: boolean;
		collapseDefault?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		loading: false,
		total: 0,
		showTotal: true,
		showTableBtn: false,
	});

	const show = ref(false);

	const activeNames = ref<any>([]);

	const checkId = ref<any>([]);
	const checkData = ref<any>([]);

	const emits = defineEmits([
		'pageChange',
		'settingAction',
		'update:pageValue',
		'row-click',
		'selection-change',
		'item-click',
	]);

	const actions = computed({
		get() {
			const arr: any = [];
			if (props.exportProps?.searchExport) {
				arr.push({ name: '搜索结果导出', code: 'searchExport' });
			}
			if (props.exportProps?.sheetExport) {
				arr.push({ name: '当前页面导出', code: 'sheetExport' });
			}
			if (props.exportProps?.allExport) {
				arr.push({ name: '全量数据导出', code: 'allExport' });
			}
			return arr;
		},
		set(val) {
			emits('update:pageValue', val);
		},
	});

	const indexcolumnList = computed(() => {
		let num = 0,
			total = 0;
		props.columnList.map((item, index) => {
			total += +item.cols || 24;
			if (total <= 24) {
				num = index;
			}
		});
		return num;
	});

	const pageValue = computed({
		get() {
			return props.pageValue || { pageNum: 1, pageSize: 10 };
		},
		set(val) {
			emits('update:pageValue', val);
		},
	});

	watch(
		pageValue,
		(newVal) => {
			emits('pageChange', newVal);
		},
		{
			deep: true,
		},
	);

	watch(
		() => props.data,
		(newVal) => {
			if (props.collapse) {
				if (props.collapseDefault) {
					activeNames.value = [];
				} else {
					activeNames.value = newVal.map((item) => item[props.rowKey]);
				}
			} else {
				activeNames.value = newVal.map((item) => item[props.rowKey]);
			}
		},
		{
			immediate: true,
			deep: true,
		},
	);

	watch(
		() => [props.collapse, props.collapseDefault],
		(newValue) => {
			if (newValue[0]) {
				if (newValue[1]) {
					activeNames.value = [];
				} else {
					activeNames.value = props.data.map((item) => item[props.rowKey]);
				}
			} else {
				activeNames.value = props.data.map((item) => item[props.rowKey]);
			}
		},
		{
			deep: true,
		},
	);

	const settingAction = (type, scope, ...args) => {
		emits('settingAction', type, scope, ...args);
	};

	const onExport = (obj: any) => {
		const params = (props.exportProps || {})[obj.code];
		if (params) {
			typeof props.exportProps![obj.code] === 'function'
				? params()
				: download(params.url, params.params, params.name, params.headers);
		}
	};

	const handleRowClick = (val) => {
		emits('row-click', val);
	};

	const handleItemClick = (e, val, isClick) => {
		if (isClick) {
			e.stopPropagation();
			emits('item-click', val);
		}
	};

	const getSelectionRows = () => {
		return checkData.value;
	};

	const setSelectionRows = (val) => {
		checkData.value = val;
		checkId.value = val.map((item) => item[props.rowKey]);
	};

	const handleSelectionChange = (val) => {
		const dataArr: any = [];
		val.forEach((id) => {
			checkData.value.forEach((item) => {
				if (id === item[props.rowKey]) {
					dataArr.push(item);
				}
			});
		});
		val.forEach((id) => {
			props.data.forEach((item) => {
				if (id === item[props.rowKey]) {
					dataArr.push(item);
				}
			});
		});
		const uniqueArr = Array.from(new Set(dataArr.map((item) => item[props.rowKey]))).map((id) =>
			dataArr.find((item) => item[props.rowKey] === id),
		);

		checkData.value = uniqueArr;
		emits('selection-change', uniqueArr);
	};

	defineExpose({ getSelectionRows, setSelectionRows });
</script>

<style lang="scss" scoped>
	.table-btns {
		padding: 12px 12px 0 12px;
	}

	.data-list {
		//padding: 12px;
		//background: #f6f6f6;

		.data-item {
			margin: 5px 0;
			background: #fff;
			border-radius: 10px;
			padding: 5px 0;

			.checkbox-box {
				display: flex;
				justify-content: end;
			}

			.width-100 {
				width: 100%;
			}

			.data-title {
				padding: 0 10px;
				font-weight: bold;
				position: relative;
				width: 100%;
				word-break: break-all;
				color: #252525;
				font-size: 15px;
				display: flex;

				&::after {
					position: absolute;
					top: 50%;
					left: 0;
					width: 4px;
					height: 16px;
					background-color: var(--theme-color-primary);
					transform: translateY(-50%);
					content: '';
				}
			}

			.label-padding {
				padding: 0px 5px;
			}

			:deep(.van-collapse-item__content),
			:deep(.van-collapse-item__title) {
				padding: 0px 5px;
			}

			:deep(.van-field__label) {
				margin-right: 5px;
				color: #a9a9a9;
				font-size: 13px;
			}

			:deep(.van-field__control) {
				color: #a9a9a9;
				font-size: 13px;
			}
		}
	}
</style>
